import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import FrequentlyAskedQuestionView from './FrequentlyAskedQuestionView';

export const FrequentlyAskedQuestionController = props => {
  const { frequentlyAskedQuestion, isExpanded = false } = props;

  const loading = props.globalLoadingFlag;

  if (loading) {
    return <LoadingMask />;
  } else
    return (
      <FrequentlyAskedQuestionView
        frequentlyAskedQuestion={frequentlyAskedQuestion}
        isExpanded={isExpanded}
      />
    );
};
